import React from "react"


const AbrName = ({ val, rem }) => {

    // get abreviated name //
    const nameArray = val.split(' ')
    const initial = nameArray[0][0] + '. '
    const nameAbr = initial + nameArray.slice(1, nameArray.length)

    return (
        <div style={{
            // display : 'flex',
            alignItems: 'center',
            justifyContent: 'start',
            fontSize: rem+'rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: 'calc(100% - 10px)',
            whiteSpace: 'nowrap',
            display: 'block',
        }}>
            {initial === 'undefined. ' ? '   --' : nameAbr}
        </div>
    )
    
}

export default AbrName